export const apiField = 'ground_elevation_factor_ke';
export default {
  type: 'Text',
  label: 'groundElevationFactorKe',
  missing: undefined,
  apiField,
  tooltip: undefined,
};

